import { render, staticRenderFns } from "./Mys.vue?vue&type=template&id=28c1b68c&"
import script from "./Mys.vue?vue&type=script&lang=js&"
export * from "./Mys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports